class NoValidatedSD {
  constructor({
    id = '',
    fileName = '',
    template = '',
    mysqlId = '',
    createdAt = '',
    supplier = '',
    model = '',
    docket_number = '',
    arriving_date = '',
    delivery_note_data = {},
  }) {
    this.id = id;
    this.fileName = fileName;
    this.template = template;
    this.mysqlId = mysqlId;
    this.createdAt = createdAt;
    this.supplier = supplier;
    this.model = model;
    this.docket_number = docket_number;
    this.arriving_date = arriving_date;
    this.delivery_note_data = delivery_note_data;
  }
}

export default NoValidatedSD;
